import { getEUConsentString } from 'util/consent';

/**
 * Renders the src attribute string for the Triton idSync script
 * @param {string} mountPoint
 * @return {string}
 */
function renderSrc(mountPoint) {
  const consentString = getEUConsentString();
  const gdpr = consentString ? 1 : 0;
  const cs = consentString || '';

  return `https://playerservices.live.streamtheworld.com/api/idsync.js?mount=${mountPoint}&gdpr=${gdpr}&gdpr_consent=${cs}`;
}

/**
 * Initializes cookie synchronization for a Triton station
 * @param {string} mountPoint
 */
export default function setCookieSync(mountPoint) {
  const id = 'idSyncScript';
  let el = document.getElementById(id);

  if (el) {
    el.parentNode.removeChild(el);
  }

  el = document.createElement('script');
  el.id = id;
  el.src = renderSrc(mountPoint);

  document.body.appendChild(el);
}
